export default __webpack_public_path__ + "static/media/pop-white.db84274b.svg";